import {
    TOGGLE_SELECTED, SET_READY, SHOW_ERROR, RESET_ERROR
} from 'constants/actionTypes/paypal';
import Actions from 'Actions';
import localeUtils from 'utils/LanguageLocale';
import PayPalEN from 'constants/locales/PayPal_en_US';
import PayPalFR from 'constants/locales/PayPal_fr_CA';

export function toggleSelect(isSelected) {
    return {
        type: TOGGLE_SELECTED,
        isSelected
    };
}

export function setReady(isReady) {
    return {
        type: SET_READY,
        isReady
    };
}

export function showError(errorMessage) {
    return {
        type: SHOW_ERROR,
        error: {
            errorMessage
        }
    };
}

export function resetError() {
    return {
        type: RESET_ERROR
    };
}

/**
 * Show error modal for PayPal payment errors
 * Displays a localized error message when PayPal SDK fails, user cancels payment, or authorization fails.
 * Used in both Express flow (Basket) and Frictionless flow (Checkout).
 *
 * Follows Venmo error handling pattern (VenmoActions.js:25-33)
 *
 * @param {object} [options] - Error options
 * @param {boolean} [options.isCancellation=false] - True if user cancelled PayPal flow
 * @param {boolean} [options.isAuthorizationFailure=false] - True if PayPal authorization failed
 * @returns {object} InfoModal action with title, message, and OK button
 */
export function showModalError({ isCancellation = false, isAuthorizationFailure = false } = {}) {
    const getText = localeUtils.getLocalisedDataFromResource(PayPalEN, PayPalFR);

    // Determine which message to show based on error type
    let messageKey = 'paymentErrorMessage'; // Default: SDK/API errors

    if (isCancellation) {
        messageKey = 'paymentCancellation';
    } else if (isAuthorizationFailure) {
        messageKey = 'authorizationErrorMessage';
    }

    return Actions.showInfoModal({
        isOpen: true,
        isHtml: true,
        title: getText('paymentErrorTitle'),
        message: getText(messageKey),
        buttonText: getText('okButton')
    });
}
